import * as ng from 'angular';

const MODULE_NAME = 'app';
ng.module(MODULE_NAME, ['shop', 'services', 'filters']);
export default MODULE_NAME;
